module.exports = __webpack_public_path__ + "static/media/calendarPagePreview.f039b1e7.svg";